import { http } from "./http.js";

async function getReleaseOrder(id) {
	const response = await http.get(`release-orders/${id}`);
	return {
		id: response.data.Id,
		needSync: response.data.NeedSync,
		hasNotArrivedShippings: response.data.HasNotArrivedShippings,
		releaseOrderPlan: response.data.ReleaseOrderPlan,
		releaseOrderFact: response.data.ReleaseOrderFact,
		releaseOrderPeriod: response.data.ReleaseOrderPeriod
			? {
				id: response.data.ReleaseOrderPeriod.Id,
				title: response.data.ReleaseOrderPeriod.Title,
			}
			: null,
		senderAddress: response.data.SenderAddress
			? {
				id: response.data.SenderAddress.Id,
				title: response.data.SenderAddress.Title,
			}
			: null,
		transport: response.data.Transport
			? {
				registrationNumber: response.data.Transport.RegistrationNumber,
				driver:
					response.data.Transport.Driver?.Surname ||
						response.data.Transport.Driver?.Name ||
						response.data.Transport.Driver?.Middlename
						? {
							surname: response.data.Transport.Driver?.Surname,
							name: response.data.Transport.Driver?.Name,
							middlename: response.data.Transport.Driver?.Middlename,
						}
						: null,
				phone: response.data.Transport.Phone,
			}
			: null,
		courier: {
			company: response.data.CourierService
				? {
					id: response.data.CourierService.Id,
					title: response.data.CourierService.Title,
				}
				: null,
			waybillNumber: response.data.WaybillNumber,
		},
		transportType: response.data.TransportType.Id,
		arrivalPlaces:
			response.data.ArrivalPlaces && response.data.ArrivalPlaces.length
				? response.data.ArrivalPlaces.map(i => {
					return {
						id: i.Id,
						address: i.Address
					};
				})
				: [],
		isRemoved: response.data.IsRemoved,
	};
}

async function updateReleaseOrders(id, newOrder) {
	await http.put(`release-orders/${id}`, newOrder);
}

async function createReleaseOrders(newOrder) {
	const res = await http.post("release-orders", newOrder);
	return res.data;
}

async function createReleaseOrdersShipping(id, value) {
	const res = await http.post(`release-orders/${id}/shippings`, value);
	return res.data;
}

async function updateReleaseOrdersShipping(id, orderShippingId, newShipping) {
	await http.put(
		`release-orders/${id}/shippings/${orderShippingId}`,
		newShipping,
	);
}

async function saveReleaseOrdersShippingsPosition(id, shippingId, to) {
	await http.patch(`release-orders/${id}/shippings/${shippingId}/position`, {
		value: to,
	});
}

async function deleteReleaseOrdersShipping(id, orderShippingId) {
	await http.delete(`release-orders/${id}/shippings/${orderShippingId}`);
}

async function getReleaseOrdersShippings(id) {
	const response = await http.get(`release-orders/${id}/shippings`);
	return response.data.map(i => {
		return {
			id: i.Id,
			shippingId: i.ShippingId,
			shippingNumber: i.ShippingNumber,
			routeNumber: i.RouteNumber,
			number: i.Number,
			client: {
				id: i.Client.Id,
				title: i.Client.Title,
			},
			sender: i.Sender
				? {
					id: i.Sender.Id,
					title: i.Sender.Title,
				}
				: null,
			volume: i.Volume,
			cargoPlaces: i.CargoPlaces,
			isPartialPlan: i.IsPartialPlan,
			isPartialFact: i.IsPartialFact,
			notes: i.Notes,
			released: i.Released,
			arrivalPlaceId: i.ArrivalPlace ? i.ArrivalPlace.Id : 0,
			releasedVolume: i.ReleasedVolume,
			releasedCargoSizes: i.ReleasedCargoSizes,
			releasedCargoPlaces: i.ReleasedCargoPlaces,
			releasedPackingMethod: i.ReleasedPackingMethod,
			isShipped: i.IsShipped,
		};
	});
}

async function getReleaseOrdersShippingsByName(filter) {
	const res = await http.get("shippings/by-number", { params: filter });
	return res.data.map(i => {
		return {
			id: i.Id,
			title: i.Title,
		};
	});
}
async function changeSenderAddress(id, addressId) {
	await http.patch(`release-orders/${id}/sender-address`, {
		value: addressId,
	});
}
async function reschedule(id, date) {
	await http.patch(`release-orders/${id}/reschedule`, { value: date });
}
async function changeReleaseOrderUnloadPeriod(id, periodId) {
	await http.patch(`release-orders/${id}/unload-period`, { value: periodId });
}
async function changeReleaseOrderDeliveryInfo(id, companyId, waybillNumber) {
	await http.patch(`release-orders/${id}/delivery-info`, {
		companyId,
		waybillNumber,
	});
}
async function changeReleaseOrderTransport(
	id,
	registrationNumber,
	driver,
	phone,
) {
	await http.patch(`release-orders/${id}/transport`, {
		registrationNumber,
		driver,
		phone,
	});
}
async function updateTransportType(id, value) {
	await http.patch(`release-orders/${id}/transport-type`, { value });
}
async function createArrivalPlace(id, value) {
	const response = await http.post(
		`release-orders/${id}/arrival-places`,
		value,
	);
	return response;
}
async function deleteArrivalPlace(id, arrivalPlaceId) {
	await http.delete(`release-orders/${id}/arrival-places/${arrivalPlaceId}`);
	return true;
}
async function updateShippingArrivalPlace(id, shippingId, placeId) {
	const response = await http.patch(
		`release-orders/${id}/shippings/${shippingId}/arrival-place`,
		{ value: placeId },
	);
	return response;
}

async function updateArrivalPlace(id, arrivalPlaceId, arrivalPlace) {
	const response = await http.put(
		`release-orders/${id}/arrival-places/${arrivalPlaceId}`,
		arrivalPlace,
	);
	return response;
}

async function changeRemovedState(id, value) {
	const response = await http.patch(`/release-orders/${id}/removed`, {
		value: !value,
	});
	return response;
}

async function getReleaseOrdersShipping(id) {
	const response = await http.get(
		`/release-orders/shippings/${id}/measurements-info`,
	);
	if (response.data) {
		return {
			shippingId: response.data.ShippingId,
			volume: response.data.Volume,
			cargoPlaces: response.data.CargoPlaces,
		};
	} else {
		return null;
	}
}

export {
	getReleaseOrder,
	updateReleaseOrders,
	createReleaseOrders,
	createReleaseOrdersShipping,
	updateReleaseOrdersShipping,
	getReleaseOrdersShippings,
	getReleaseOrdersShippingsByName,
	deleteReleaseOrdersShipping,
	saveReleaseOrdersShippingsPosition,
	changeSenderAddress,
	reschedule,
	changeReleaseOrderUnloadPeriod,
	changeReleaseOrderDeliveryInfo,
	changeReleaseOrderTransport,
	updateTransportType,
	createArrivalPlace,
	deleteArrivalPlace,
	updateShippingArrivalPlace,
	updateArrivalPlace,
	changeRemovedState,
	getReleaseOrdersShipping,
};
